import { observer } from 'mobx-react';
import React from 'react';
import { Route, Routes } from 'react-router-dom';

import LessonPage from './Lesson';
import ProgramPage from './Program';
import ProgramsPage from './Programs';

function ProgramsRoute() {
	return (
		<Routes>
			<Route path=":programId/:groupId/:programGroupId" element={<ProgramPage />} />
			<Route
				path=":programId/:groupId/:programGroupId/:scheduleLessonId"
				element={<LessonPage />}
			/>
			<Route path="*" element={<ProgramsPage />} />
		</Routes>
	);
}

export default observer(ProgramsRoute);
